export const OFFERS_PAGE_SIZE = 50
export const SKELETON_ROWS = 30
export const EXCLUDED_OFFER_TYPES = ["UNRECOGNIZED", "UNSPECIFIED"]
